<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card border-variant="primary">
          <b-card-body class="pb-0">
            <h1 class="text-center mb-4">{{ t('settings_invoice-title') }}</h1>
            <b-row>
              <b-col sm="6" offset="3">
                <b-alert variant="danger" show class="text-center" v-if="!blocked">{{ t('settings_invoice-warning') }}</b-alert>
              </b-col>
              <b-col sm="6" offset="3">
                <b-form-group>
                  <b-form-select
                    :disabled="blocked"
                    :plain="true"
                    v-model="details.type"
                    :options="whoOptions">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="6" offset="3" v-if="details.type !== ''">
                <b-form-group>
                  <b-form-input :placeholder="details.type === 'ue_company' ? t('settings_invoice-company') : details.type === 'ue_indyvidual' ? t('settings_invoice-name-only') : t('settings_invoice-name')" type="text" v-model="details.name" :readonly="blocked"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6" offset="3" v-if="details.type !== ''">
                <b-form-group>
                  <b-form-input :placeholder="t('settings_invoice-address')" type="text" v-model="details.address" :readonly="blocked"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6" offset="3" v-if="details.type !== ''">
                <b-form-group>
                  <b-form-input :placeholder="t('settings_invoice-city')" type="text" v-model="details.city" :readonly="blocked"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6" offset="3" v-if="details.type !== ''">
                <b-form-group>
                  <b-form-input :placeholder="t('settings_invoice-state')" type="text" v-model="details.state" :readonly="blocked"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6" offset="3" v-if="details.type !== ''">
                <b-form-group>
                  <b-form-input :placeholder="t('settings_invoice-postal')" type="text" v-model="details.postal" :readonly="blocked"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6" offset="3" v-if="details.type === 'ue_company'">
                <h3 class="text-center mb-4">{{ t('settings_invoice-vat-info') }}</h3>
                <b-form-group>
                  <b-form-input :placeholder="t('settings_invoice-vat')" type="text" v-model="details.vat" :readonly="blocked"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6" offset="3" v-if="details.type === 'ue_indyvidual'">
                <b-form-group>
                  <b-form-select
                    :disabled="blocked"
                    :plain="true"
                    v-model="details.country"
                    :options="countryOptions">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="6" offset="3">
                <b-button type="submit" block variant="primary" @click="onInvoiceDetailsSave()" :disabled="!canSave">{{ t('global_save') }}</b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="12">
        <b-card border-variant="primary">
          <b-card-body class="pb-0">
            <b-row>
              <b-col sm="6" offset="3">
                <h1 class="text-center mb-4">{{ t('settings_dripfeed-api-title') }}</h1>
                <b-form-group>
                  <b-form-select
                    :plain="true"
                    v-model="dripfeed.api"
                    :options="options">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="6" offset="3">
                <h1 class="text-center my-4">{{ t('settings_dripfeed-title') }}</h1>
                <b-form-group>
                  <b-form-select
                    :plain="true"
                    v-model="dripfeed.main"
                    :options="options">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="6" offset="3">
                <b-button type="submit" block variant="primary" @click="onDefaultDripfeedSave()">{{ t('global_save') }}</b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "Settings",
  data() {
    return {
      whoOptions: [
        {
          text: "",
          value: "",
          disabled: true,
          selected: true
        },
        {
          text: "",
          value: "ue_indyvidual"
        },
        {
          text: "",
          value: "ue_company"
        },
        {
          text: "",
          value: "non_ue"
        }
      ],
      countryOptions: [
        {
          text: "",
          value: "",
          disabled: true,
          selected: true
        },
        {
          text: "Poland (PL)",
          value: "PL"
        },
        { text: "Austria (AT)", value: "AT" },
        { text: "Belgium (BE)", value: "BE" },
        { text: "Bulgaria (BG)", value: "BG" },
        { text: "Croatia (HR)", value: "HR" },
        { text: "Cyprus (CY)", value: "CY" },
        { text: "Czechia (CZ)", value: "CZ" },
        { text: "Denmark (DK)", value: "DK" },
        { text: "Estonia (EE)", value: "EE" },
        { text: "Finland (FI)", value: "FI" },
        { text: "France (FR)", value: "FR" },
        { text: "Greece (GR)", value: "GR" },
        { text: "Spain (ES)", value: "ES" },
        { text: "Ireland (IE)", value: "IE" },
        { text: "Lithuania (LT)", value: "LT" },
        { text: "Luxemburg (LU)", value: "LU" },
        { text: "Latvia (LV)", value: "LV" },
        { text: "Malta (MT)", value: "MT" },
        { text: "Netherlands (NL)", value: "NL" },
        { text: "Germany (DE)", value: "DE" },
        { text: "Poland (PL)", value: "PL" },
        { text: "Portugal (PT)", value: "PT" },
        { text: "Romania (RO)", value: "RO" },
        { text: "Slovakia (SK)", value: "SK" },
        { text: "Slovenia (SI)", value: "SI" },
        { text: "Sweden (SE)", value: "SE" },
        { text: "Hungary (HU)", value: "HU" },
        { text: "Italy (IT)", value: "IT" }
      ],
      details: {
        type: "",
        country: "",
        name: "",
        address: "",
        city: "",
        state: "",
        postal: "",
        vat: ""
      },
      blocked: false,
      options: [],
      dripfeed: {
        main: 1,
        api: 1
      }
    };
  },
  computed: {
    canSave() {
      return this.details.type !== "" && !this.blocked;
    }
  },
  methods: {
    onInvoiceDetailsSave() {
      const name = this.details.name.trim();
      const address = this.details.address.trim();
      const city = this.details.city.trim();
      const state = this.details.state.trim();
      const postal = this.details.postal.trim();
      const vat = this.details.vat.trim();
      const type = this.details.type.trim();
      const country = this.details.country.trim();

      if (
        name === "" ||
        address === "" ||
        city === "" ||
        state === "" ||
        postal === "" ||
        (type === "ue_indyvidual" && country === "") ||
        (type === "ue_company" && vat === "")
      ) {
        Vue.swal(this.$translate.text("settings_please-fill"), "", "warning");
      } else {
        const that = this;

        Vue.axios({
          method: "POST",
          url: "/user/settings/invoice",
          data: {
            name,
            address,
            city,
            state,
            postal,
            vat,
            type,
            country
          },
          mode: "no-cors",
          withCredentials: true,
          credentials: "same-origin"
        })
          .then(response => {
            if (response.data.status) {
              Vue.swal(this.$translate.text("global_saved"), "", "success");
              that.blocked = true;
            } else {
              Vue.swal(
                this.$translate.text(
                  response.data.message
                    ? response.data.message
                    : "global_an-unexpected-error-occurred"
                ),
                "",
                "warning"
              );
            }
          })
          .catch(() => {
            Vue.swal(
              this.$translate.text("global_an-unexpected-error-occurred"),
              "",
              "warning"
            );
          });
      }
    },
    onDefaultDripfeedSave() {
      const that = this;

      Vue.axios({
        method: "POST",
        url: "/user/settings/dripfeed",
        data: {
          dripfeed: this.dripfeed
        },
        mode: "no-cors",
        withCredentials: true,
        credentials: "same-origin"
      })
        .then(response => {
          if (response.data.status) {
            Vue.swal(this.$translate.text("global_saved"), "", "success");
          } else {
            Vue.swal(
              this.$translate.text(
                response.data.message
                  ? response.data.message
                  : "global_an-unexpected-error-occurred"
              ),
              "",
              "warning"
            );
          }
        })
        .catch(() => {
          Vue.swal(
            this.$translate.text("global_an-unexpected-error-occurred"),
            "",
            "warning"
          );
        });
    }
  },
  beforeMount() {
    this.countryOptions[0].text = this.$translate.text(
      "settings_invoice-country"
    );

    this.whoOptions[0].text = this.$translate.text("settings_invoice-who");
    this.whoOptions[1].text = this.$translate.text("settings_invoice-who1");
    this.whoOptions[2].text = this.$translate.text("settings_invoice-who2");
    this.whoOptions[3].text = this.$translate.text("settings_invoice-who3");

    const that = this;

    for (let i = 1; i <= 30; i++) this.options.push(i);

    Vue.axios({
      method: "GET",
      url: "/user/settings",
      mode: "no-cors",
      withCredentials: true,
      credentials: "same-origin"
    })
      .then(response => {
        if (response.data.status) {
          that.details = response.data.details;
          //that.details.type = ''
          //that.details.country = ''

          if (response.data.details.name !== "") this.blocked = true;
          that.dripfeed = response.data.dripfeed;
        } else {
          Vue.swal(
            this.$translate.text(
              response.data.message
                ? response.data.message
                : "global_an-unexpected-error-occurred"
            ),
            "",
            "warning"
          );
        }
      })
      .catch(() => {
        Vue.swal(
          this.$translate.text("global_an-unexpected-error-occurred"),
          "",
          "warning"
        );
      });
  }
};
</script>
